// extracted by mini-css-extract-plugin
export default {"emojiPickerContainer":"xZdLMEJ8XmV_fY3r4lha","picker":"QUUoesksga4swHtMBFtv"};